// =============================================================================
// features/configuracoes/comercial/Toggle.tsx — Switch canônico (mesmo
// padrão visual de FollowupRulesPage.tsx `is_active`), extraído para reuso
// nas seções de Desfechos e Distribuição.
// =============================================================================

import * as React from 'react';

import { cn } from '../../../lib/cn';

interface ToggleProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  description?: string;
  disabled?: boolean;
}

export function Toggle({
  id,
  checked,
  onChange,
  label,
  description,
  disabled = false,
}: ToggleProps): React.JSX.Element {
  return (
    <label
      htmlFor={id}
      className={cn(
        'flex items-center gap-3',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
      )}
    >
      <div className="relative shrink-0">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only peer"
          aria-describedby={description ? `${id}-desc` : undefined}
        />
        <div
          className={cn(
            'w-10 h-5 rounded-pill transition-colors duration-[150ms]',
            checked ? 'bg-verde' : 'bg-border-strong',
            'peer-focus-visible:ring-2 peer-focus-visible:ring-azul/30',
          )}
        >
          <div
            className={cn(
              'w-4 h-4 rounded-pill bg-white transition-transform duration-[150ms] mt-0.5',
              checked ? 'translate-x-5' : 'translate-x-0.5',
            )}
            style={{ boxShadow: 'var(--elev-1)' }}
          />
        </div>
      </div>
      <div className="flex flex-col gap-0.5">
        <span className="font-sans font-medium text-ink" style={{ fontSize: 'var(--text-sm)' }}>
          {label}
        </span>
        {description && (
          <span
            id={`${id}-desc`}
            className="font-sans text-ink-3"
            style={{ fontSize: 'var(--text-xs)' }}
          >
            {description}
          </span>
        )}
      </div>
    </label>
  );
}
